import { borderRadius, colors, gridSize as akGridSize } from '@atlaskit/theme';
import { AppStateModel } from '../model/app-state.model';

export { itemThemeNamespace as themeNamespace } from '@atlaskit/item';

interface ItemProps {
  state?: AppStateModel;
}

export const theme = (props: ItemProps) => ({
  afterItemSpacing: {
    compact: akGridSize(),
    default: akGridSize(),
  },
  beforeItemSpacing: {
    compact: akGridSize(),
    default: akGridSize(),
  },
  borderRadius: borderRadius(),
  focus: {
    outline: colors.B100,
  },
  height: {
    compact: 0,
    default: 0,
  },
  padding: {
    default: {
      bottom: akGridSize() / 2,
      left: akGridSize() / 2,
      right: akGridSize() / 2,
      top: akGridSize() / 2,
    },
    compact: {
      bottom: akGridSize(),
      left: akGridSize(),
      right: akGridSize(),
      top: akGridSize(),
    },
  },
  default: {
    background: props.state.colors.ContentBackground,
    text: props.state.colors.ContentColor,
    secondaryText: props.state.colors.AltoGray,
  },
  selected: {
    background: props.state.colors.AppChrome,
    text: props.state.colors.White,
    secondaryText: props.state.colors.White,
  },
  active: {
    background: props.state.colors.AppChrome,
    text: props.state.colors.White,
    secondaryText: props.state.colors.White,
  },
  hover: {
    background: props.state.colors.BerryBlue,
    text: props.state.colors.White,
    secondaryText: props.state.colors.White,
  },
  disabled: {
    background: props.state.colors.LightGray,
    text: props.state.colors.Gray,
    secondaryText: props.state.colors.Gray,
  },
  // same as hover in this case
  dragging: {
    background: props.state.colors.BerryBlue,
    text: props.state.colors.White,
    secondaryText: props.state.colors.White,
  },
});
